<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white"> Please Wait...</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Stall Scans
        <button class="me-3" color="accent" (click)="export()"
            mat-stroked-button><mat-icon>download</mat-icon>Export</button>
    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="so_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID. </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>name</th>
                <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>
            <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>mobile</th>
                <td mat-cell *matCellDef="let element"> {{element.mobile}} </td>
            </ng-container>
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>date</th>
                <td mat-cell *matCellDef="let element"> {{element.date}} </td>
            </ng-container>
            <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>time</th>
                <td mat-cell *matCellDef="let element"> {{element.time}} </td>
            </ng-container>
            <ng-container matColumnDef="mem_id">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>mem_id</th>
                <td mat-cell *matCellDef="let element"> {{element.mem_id}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>